export default __webpack_public_path__ + "static/media/lampiran.f59be1ea.webp";